import { makeAxiosRequest } from 'utils/apiMethods';

interface GroupApi {
  fetchGroups: (data: any) => Promise<any>;
}

const groupApi: GroupApi = {
  fetchGroups: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/groups/`, {
    method: 'get',
  }),
};

export default groupApi;
